import { defineComponent as o, openBlock as r, createBlock as t, unref as l, mergeProps as p, withCtx as m, createElementVNode as v } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const s = /* @__PURE__ */ o({
  name: "IconCalendar",
  __name: "IconCalendar",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const n = a;
    return (c, e) => (r(), t(l(d), p(n, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        v("path", {
          "fill-rule": "evenodd",
          d: "M8.25 4a.75.75 0 0 0-1.5 0v1.25H4.5A2.25 2.25 0 0 0 2.25 7.5v11a2.25 2.25 0 0 0 2.25 2.25h15a2.25 2.25 0 0 0 2.25-2.25v-11a2.25 2.25 0 0 0-2.25-2.25h-2.25V4a.75.75 0 0 0-1.5 0v1.25h-7.5V4m12 5.75V7.5a.75.75 0 0 0-.75-.75h-2.25V8a.75.75 0 0 1-1.5 0V6.75h-7.5V8a.75.75 0 0 1-1.5 0V6.75H4.5A.75.75 0 0 0 3.75 7.5v2.25h16.5m-16.5 1.5h16.5v7.25a.75.75 0 0 1-.75.75h-15a.75.75 0 0 1-.75-.75v-7.25",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
